
import Vue from "vue";
import { Component } from 'vue-property-decorator';
import eventBus from "applications/desktop/eventBus"

@Component({})
export default class SearchHint extends Vue {
  eventBus = eventBus
}
